module.exports = __webpack_public_path__ + "static/NBC-Grant-800x500-c7ece8788093e4a074798c1a29310dad.jpg";